// Import of pages in the app
import Account from './Account/index';
import Account_Edit from './Account/Edit/index';
import SecureEFilingSplash from './SecureEFilingSplash/index';
import Menu from './Menu/index';
import SecureEFiling from './SecureEFiling/index';
import Login from './Login/index';
import InitiateAuth from './InitiateAuth/index';
import Callback from './Callback/index';
import Exhibits from './Exhibits/index';
import SuccessPage from './SuccessPage/index';
import SemiConfirmation from './SemiConfirmation/index';

/**
 * All of the scenes (pages) in the app (or any app you want to make a <Link/> to)
 * for use by react-navigation/core > SwitchRouter 
 */
export const scenes = {
	Menu
	, SecureEFilingSplash
	, SecureEFiling
	, Account
	, Account_Edit
	, Login
	, Callback
	, InitiateAuth
	, Exhibits
	, SuccessPage
	, SemiConfirmation
};